import type { ColumnDef } from "@tanstack/react-table";
import { capitalize, highlightText } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import type { Price } from "~/providers/general-provider";
import { SettingsHeader } from "~/components/layout/settings-header";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { useGeneral } from "~/hooks/use-general";
import { usePriceManager } from "~/managers/use-price-manager";

export const Route = createFileRoute("/_main/settings/_layout/prices")({
  component: Prices,
});

function Prices() {
  const { t } = useTranslation("common");
  const { prices } = useGeneral();
  const { openPriceDialog } = usePriceManager();
  const columns: ColumnDef<Price>[] = [
    {
      id: t("name"),
      accessorKey: "name",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("name")} />
      ),
      cell: ({ row: { original: price }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html: highlightText(price.name, globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
  ];

  return (
    <>
      <SettingsHeader
        title={t("prices")}
        buttonLabel={capitalize(t("new_price"))}
        buttonAction={async () => {
          await openPriceDialog();
        }}
      />

      <DataTable columns={columns} data={prices} onSelect={openPriceDialog} />
    </>
  );
}
